// removed by extract-text-webpack-plugin
module.exports = {"image":"image"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AddCart/index.module.less
// module id = 699
// module chunks = 438